
//上传视频
export const login = data =>
  this.$axios({
    url: "/admin/Index/checkJwtToken",
    method: "post",
    data, //传递数据的字段
    timeout: 1000 * 60 //超时 60 秒请求不到报错
  });
export const getInfo = data =>
  this.$axios({
    url: "/admin/Index/checkJwtToken",
    method: "post",
    data, //传递数据的字段
    timeout: 1000 * 60 //超时 60 秒请求不到报错
  });
